// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".WelcomePopupImage-module-mainImageContainer-we77o{width:100%;border-radius:8px;margin-bottom:1rem}@media(min-width: 960px){.WelcomePopupImage-module-mainImageContainer-we77o{width:380px;margin-bottom:0}}.WelcomePopupImage-module-mainImage-3vtAW{border-radius:8px;width:100%;-o-object-fit:cover;object-fit:cover;aspect-ratio:16/9;-o-object-position:top;object-position:top}@media(min-width: 960px){.WelcomePopupImage-module-mainImage-3vtAW{border-radius:0;aspect-ratio:auto;height:100%}}", ""]);
// Exports
exports.locals = {
	"mainImageContainer": "WelcomePopupImage-module-mainImageContainer-we77o",
	"mainImage": "WelcomePopupImage-module-mainImage-3vtAW"
};
module.exports = exports;
